<template>
    <CodiceFeanorView tool-module="asymmetric" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
